import { Button, useSelectLocationModal } from "web/components"
import { useDialogModal, DialogCommands } from "web/hooks/modals"
import { DeleteIconButton } from "web/components/IconButton"

export default function LocationList({ asset }) {
  const selectLocationModal = useSelectLocationModal()
  const dialogModal = useDialogModal()

  const { locations } = asset

  const hasLocations = Array.isArray(locations) && locations.length !== 0

  async function handleAddLocation() {
    const newLocation = await selectLocationModal()

    if (newLocation) {
      if (newLocation.place_id === null && hasLocations) {
        dialogModal({
          title: "Cannot Add Location",
          prompt:
            "You cannot add a dropped pin to an asset that has an address.",
          commands: [DialogCommands.OK],
        })
      } else {
        await asset.addLocation(newLocation)
      }
    }
  }

  async function handleRemoveLocation(location) {
    await asset.removeLocation(location.id)
  }

  return (
    <>
      {!hasLocations && (
        <div className="flex items-center justify-center rounded-md bg-neutral-6 p-5 text-white shadow-md">
          This asset has no location. Click Add Location below to add one.
        </div>
      )}
      {hasLocations && (
        <>
          <div className="my-4 text-sm text-neutral-5">
            A location in Origin is either a street address or a set of
            coordinates (i.e. a longitude and a latitude). An assets can have
            multiple locations, such as when the asset is on a corner and has an
            address on both streets. However, an asset can only have one
            physical location. So if an asset has a coordinate-based location,
            it cannot also have a street address.
          </div>
          <div className="my-2 font-bold">Current Locations</div>
          <div className="grid auto-rows-auto gap-y-2.5">
            {locations.map((location) => (
              <div
                key={location.id}
                className="grid rounded-md bg-white p-2.5 shadow"
                style={{ gridTemplateColumns: "1fr auto" }}
              >
                <span>{location.text}</span>
                {location.is_account_scoped && (
                  <DeleteIconButton
                    onClick={() => handleRemoveLocation(location)}
                    fadeUntilHover={true}
                  />
                )}
              </div>
            ))}
          </div>
        </>
      )}
      <div className="mt-4">
        <Button size="small" onClick={handleAddLocation}>
          Add Location
        </Button>
      </div>
    </>
  )
}
